import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

const APIError = (props) => {
  const { position } = props;

  const apiError = useSelector((state) => state.apiError);
  const modal = useSelector((state) => state.modal);

  const errorRef = useCallback((node) => {
    if (node !== null) {
      node.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  if (!apiError) {
    return null;
  }

  const { currentModal } = modal;

  if (
    (position === 'modal' && currentModal) ||
    (position === 'layout' && !currentModal)
  ) {
    return (
      <div
        className="c7-message c7-message--alert-error"
        role="alert"
        ref={errorRef}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        {apiError}
      </div>
    );
  }
  return null;
};

export default APIError;
